import {
  getMainPageBySlug,
  getMainPagesSlugs,
  ICarReviewLink,
  UnsupportedPageType,
} from 'app/apiCalls/kentico';
import {
  getStaticPathsSlugArray,
  getStaticPropsSlugArray,
  IPageData,
} from 'app/utils/kentico';
import { ReviewPage as ReviewPageContent } from 'app/containers/ReviewPage/ReviewPage';
import { LandingPage as LandingPageContent } from 'app/containers/LandingPage/LandingPage';

interface IReviewPageDataProps extends IPageData {
  popularModels: ICarReviewLink[];
}

const MainPage = (props: IReviewPageDataProps) => {
  if (props?.pageData?.system?.type === UnsupportedPageType.reviewPage) {
    return <ReviewPageContent {...props} />;
  }
  return <LandingPageContent {...props} />;
};

const getStaticProps = async ({ params }) => {
  return getStaticPropsSlugArray(params, getMainPageBySlug);
};

const getStaticPaths = async () => {
  return getStaticPathsSlugArray(getMainPagesSlugs);
};

export { MainPage, getStaticPaths, getStaticProps };
